/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button, Grid, MenuItem, Popover, Tooltip, Typography } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
//
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnClear, BtnExportExcel, BtnIconSearch, BtnSearch } from 'components/Common/Button';
import { AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import Accordion from 'components/Common/Accordion/Accordion';
import DateRangePicker from 'components/Common/ElementInForm/DateRange';
import moment from 'moment';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import {
    DataGridMui as Table,
    initRows,
    PaginationInterface,
} from "components/Common/Table/DataGridMui";
import { GridColumns } from '@mui/x-data-grid-pro';
import { Link, useNavigate } from 'react-router-dom';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import Zoom from '@mui/material/Zoom';
import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
import DatePickerLangFormItem from 'components/Common/ElementInForm/DatePickerLangFormItem';
const i18nField = 'entities.MyVOCList.fields';
const ListProblem = (props) => {

    const { GetDashboard,CardAction, Option } = props;

    const [loadingTable, setLoadingTable] = useState(true);
    const [MinDate, setMinDate] = useState(null as any)
    const [MaxDate, setMaxDate] = useState(null as any)
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dIssueDate",
        sSortDirection: "desc"
    });

    //#region  Form
    let objSchema = {
        sJobCode: yupFormSchemas.string(i18n(`${i18nField}.sSheet`), { required: false }),
        sVOCFormCode: yupFormSchemas.string(i18n(`${i18nField}.sInvoice`), { required: false }),
        sDetail: yupFormSchemas.string(i18n(`${i18nField}.sDetail`), { required: false }),
        arrTypeVOC: yupFormSchemas.stringArray(i18n(`${i18nField}.sType`), { required: false }),
        sIssueDateStart: yupFormSchemas.string(i18n(`${i18nField}.sDateStart`), { required: false }),
        sIssueDateEnd: yupFormSchemas.string(i18n(`${i18nField}.sDateEnd`), { required: false }),
        // arrDateIssue: yupFormSchemas.stringArray(i18n(`${i18nField}.sDate`), { required: false }),
        arrStatus: yupFormSchemas.stringArray(i18n(`${i18nField}.sStatusSheet`), { required: false }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        if (props.CardAction == 1) {
            // form.setValue("arrDateIssue", [new Date(new Date().getFullYear(), new Date().getMonth(), 1), null])
            let startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            form.setValue("sIssueDateStart", startDate)
            setMinDate(startDate)
            loadData()
        }
    }, [props.CardAction])

    const loadData = (p: PaginationInterface = dataRow) => {
        setLoadingTable(true)

        let obj = {
            ...p,
            "sLanguage": currentLanguage(),
            "nCardBox": 1,
            "sVOCFormCode": form.getValues("sVOCFormCode") ?? null,
            "lstVOCTypeID": form.getValues("arrTypeVOC") ? form.getValues("arrTypeVOC") : null,
            "sSearch": form.getValues("sDetail") ?? null,
            "sIssueDateStart": form.getValues("sIssueDateStart") ? (moment(form.getValues("sIssueDateStart"))).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("sIssueDateEnd") ? (moment(form.getValues("sIssueDateEnd"))).format("DD/MM/YYYY") + "" : null,
            "sJobCode": form.getValues("sJobCode") ?? null,
            "lstStatusID": form.getValues("arrStatus") ? form.getValues("arrStatus") : null,
        }
        AxiosPost(`MyVOC/SearchListMyVOC`, obj, (res) => {
            // UnBlockUI();
            ResultAPI(res, null, () => {
                setLoadingTable(false)
                setDataRow({
                    ...p,
                    arrRows: res.result.data || [],
                    nDataLength: res.result.nDataLength,
                    nPageIndex: res.result.nPageIndex,
                });
            })
        })
        if (GetDashboard) {
            GetDashboard()
        }
    };

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: i18n(`${i18nField}.sCol0`),
            headerAlign: "center",
            width: 50,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sVOCFormCode",
            headerName: i18n(`${i18nField}.sCol3`),
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
            renderCell: (item) => {
                return (
                    <>
                        <Link
                            to={"/Front/MyVOC/HomeVOCForm"}
                            state={{ sVOCFormID: item.row.sVOCFormID }}
                            style={{ color: "#228dbd", textDecoration: "underline", cursor: "pointer" }}
                        >
                            {item.value}
                        </Link>
                    </>
                );
            },
        },
        {
            field: "dIssueDate",
            headerName: i18n(`${i18nField}.sCol1`),
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ?
                    (currentLanguage() == "th" ?
                        moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.")
                        : moment(item.value).format("DD/MM/YYYY HH:mm"))
                    : null;

                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sVOCType",
            headerName: i18n(`${i18nField}.sCol2`),
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
            renderCell: (item) => {
                return (
                    <Typography component={"label"}>{item.value} </Typography>
                );
            },
        },
        {
            field: "sDetail",
            headerName: i18n(`${i18nField}.sCol7`),
            headerAlign: "center",
            flex: 4,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
            renderCell: (item) => {
                return (
                    <Tooltip title={item.value} TransitionComponent={Zoom} placement="top-start" >
                        <Typography component={"label"}>{item.value} </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: "sJobCode",
            headerName: i18n(`${i18nField}.sCol4`),
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
        {
            field: "sBA",
            headerName: i18n(`${i18nField}.sCol8`),
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
        {
            field: "sResponAction",
            headerName: i18n(`${i18nField}.sCol5`),
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
        {
            field: "sStatus",
            headerName: i18n(`${i18nField}.sCol6`),
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
    ];

    return (
        <>
            <FormProvider {...form}>
                <Accordion header={i18n(`${i18nField}.sReport`)}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                        <Grid item xs={12}>
                            <Grid container spacing={1} direction="row" justifyContent="end" alignItems="center" >
                                <Grid item xs={12} sm={6} md={1.5}>
                                    <InputFormItem
                                        id="sVOCFormCode"
                                        name="sVOCFormCode"
                                        label={i18n(`${i18nField}.sInvoice`)}
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    <MultiSelectForm
                                        name="arrTypeVOC"
                                        options={Option.lstVOCType || []}
                                        label={i18n(`${i18nField}.sType`)}
                                        required={false}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    <InputFormItem
                                        id="sDetail"
                                        name="sDetail"
                                        label={i18n(`${i18nField}.sDetail`)}
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    {/* <DateRangePicker
                                        label={i18n(`${i18nField}.sDateStart`)}
                                        lableEnd={i18n(`${i18nField}.sDateEnd`)}
                                        require={false}
                                        name="arrDateIssue"
                                    /> */}
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="flex-start">
                                        <Grid item xs={12} md={6}>
                                            <DatePickerLangFormItem
                                                name="sIssueDateStart"
                                                label={i18n(`${i18nField}.sDateStart`)}
                                                required={false}
                                                maxDate={MaxDate}
                                                onChange={(e) => { setMinDate(e); }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <DatePickerLangFormItem
                                                name="sIssueDateEnd"
                                                label={i18n(`${i18nField}.sDateEnd`)}
                                                required={false}
                                                minDate={MinDate}
                                                onChange={(e) => { setMaxDate(e); }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={6} md={1.5}>
                                    <InputFormItem
                                        id="sJobCode"
                                        name="sJobCode"
                                        label={i18n(`${i18nField}.sSheet`)}
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={1.5}>
                                    <MultiSelectForm
                                        name="arrStatus"
                                        options={Option.lstStatus || []}
                                        label={i18n(`${i18nField}.sStatusSheet`)}
                                        required={false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={'auto'}>
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                        <Grid item>
                                            <BtnIconSearch onClick={() => { loadData() }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Table
                                isLoading={loadingTable}
                                OnLoadData={(p) => loadData(p)}
                                Rows={dataRow}
                                HiddenToolHead={true}
                                Columns={dataColumn}
                                backgroundHeaderCustom={"#004290"}
                                sxCustomHeader={{ color: '#ffffff' }}
                            />
                        </Grid>
                    </Grid>
                </Accordion>
            </FormProvider>
        </>
    )
}

export default ListProblem